import apiClient from './apiClient';
import { ApiResponse, PaginatedResponse } from '../../types/common';
import {
  FAQ,
  FaqFormData,
  Notice,
  NoticeFormData,
  OfficialContact,
  ContactFormData,
} from '../../types/content';

// FAQ APIs
export const getFaqs = async (
  filters?: { page?: number; limit?: number }
): Promise<PaginatedResponse<FAQ>> => {
  const response = await apiClient.get<ApiResponse<PaginatedResponse<FAQ>>>('/admin/content/faq', {
    params: filters,
  });

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || 'FAQ 목록 조회???�패?�습?�다.');
  }

  return response.data.data;
};

export const createFaq = async (data: FaqFormData): Promise<FAQ> => {
  const response = await apiClient.post<ApiResponse<FAQ>>('/admin/content/faq', data);

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || 'FAQ ?�성???�패?�습?�다.');
  }

  return response.data.data;
};

export const updateFaq = async (id: string, data: Partial<FaqFormData>): Promise<FAQ> => {
  const response = await apiClient.put<ApiResponse<FAQ>>(`/admin/content/faq/${id}`, data);

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || 'FAQ 수정에 실패했습니다.');
  }

  return response.data.data;
};

export const deleteFaq = async (id: string): Promise<void> => {
  const response = await apiClient.delete<ApiResponse<void>>(`/admin/content/faq/${id}`);

  if (response.data.status !== 200) {
    throw new Error(response.data.message || 'FAQ 삭제에 실패했습니다.');
  }
};

// Notice APIs
export const getNotices = async (
  filters?: { page?: number; limit?: number }
): Promise<PaginatedResponse<Notice>> => {
  const response = await apiClient.get<ApiResponse<PaginatedResponse<Notice>>>('/admin/content/notice', {
    params: filters,
  });

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '공�??�항 목록 조회???�패?�습?�다.');
  }

  return response.data.data;
};

export const createNotice = async (data: NoticeFormData): Promise<Notice> => {
  const response = await apiClient.post<ApiResponse<Notice>>('/admin/content/notice', data);

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '공�??�항 ?�성???�패?�습?�다.');
  }

  return response.data.data;
};

export const updateNotice = async (id: string, data: Partial<NoticeFormData>): Promise<Notice> => {
  const response = await apiClient.put<ApiResponse<Notice>>(`/admin/content/notice/${id}`, data);

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '공지사항 수정에 실패했습니다.');
  }

  return response.data.data;
};

export const deleteNotice = async (id: string): Promise<void> => {
  const response = await apiClient.delete<ApiResponse<void>>(`/admin/content/notice/${id}`);

  if (response.data.status !== 200) {
    throw new Error(response.data.message || '공지사항 삭제에 실패했습니다.');
  }
};

// Official Contact APIs
export const getContacts = async (
  filters?: { page?: number; limit?: number; category?: string }
): Promise<PaginatedResponse<OfficialContact>> => {
  const response = await apiClient.get<ApiResponse<PaginatedResponse<OfficialContact>>>(
    '/admin/content/contacts',
    { params: filters }
  );

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '?�락�?목록 조회???�패?�습?�다.');
  }

  return response.data.data;
};

export const createContact = async (data: ContactFormData): Promise<OfficialContact> => {
  const response = await apiClient.post<ApiResponse<OfficialContact>>('/admin/content/contacts', data);

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '?�락�?추�????�패?�습?�다.');
  }

  return response.data.data;
};

export const updateContact = async (
  id: string,
  data: Partial<ContactFormData>
): Promise<OfficialContact> => {
  const response = await apiClient.put<ApiResponse<OfficialContact>>(
    `/admin/content/contacts/${id}`,
    data
  );

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '연락처 수정에 실패했습니다.');
  }

  return response.data.data;
};

export const deleteContact = async (id: string): Promise<void> => {
  const response = await apiClient.delete<ApiResponse<void>>(`/admin/content/contacts/${id}`);

  if (response.data.status !== 200) {
    throw new Error(response.data.message || '연락처 삭제에 실패했습니다.');
  }
};

export const importContactsFromCsv = async (file: File): Promise<{ imported: number }> => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiClient.post<ApiResponse<{ imported: number }>>(
    '/admin/content/contacts/import',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || 'CSV ?�괄 ?�록???�패?�습?�다.');
  }

  return response.data.data;
};

export const removeDuplicateContacts = async (): Promise<{ deletedCount: number }> => {
  const response = await apiClient.delete<ApiResponse<{ deletedCount: number }>>(
    '/admin/content/contacts/duplicates/remove'
  );

  if (response.data.status !== 200 || !response.data.data) {
    throw new Error(response.data.message || '중복 제거에 실패했습니다.');
  }

  return response.data.data;
};
